import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { fetchWithCSRFTokenForRequestObject } from "Utils/fetchWithCSRFToken";
import { EmployeeHealthAccount, EmployeeHealthAccountEditable } from "Utils/types";

import { appendAuthParams } from "Common/TokenAuth/Utils";

interface EmployeePolicyIDArgs {
  employeePolicyID: string | number;
}
interface EmployeeHealthAccountResponse {
  employeeHealthAccount: EmployeeHealthAccount;
}

interface UpdateEmployeeHealthAccountArgs {
  employeeFormID: string | number;
  employeeHealthAccount: EmployeeHealthAccountEditable;
}

export const employeeHealthAccountApi = createApi({
  reducerPath: "employeeHealthAccountApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/v2/",
    fetchFn: fetchWithCSRFTokenForRequestObject,
  }),

  endpoints: (builder) => ({
    getEmployeeHealthAccount: builder.query<EmployeeHealthAccountResponse, EmployeePolicyIDArgs>({
      query: ({ employeePolicyID }) => {
        return appendAuthParams(`employee_policies/${employeePolicyID}/employee_health_accounts`);
      },
      providesTags: ["EmployeeHealthAccount"],
    }),

    updateEmployeeHealthAccount: builder.mutation<EmployeeHealthAccountResponse, UpdateEmployeeHealthAccountArgs>({
      query: ({ employeePolicyID, employeeHealthAccount }) => ({
        url: appendAuthParams(`employee_policies/${employeePolicyID}/employee_health_accounts`),
        method: "put",
        body: { employeeHealthAccount },
      }),
      invalidatesTags: ["EmployeeHealthAccount"],
    }),
  }),

  tagTypes: ["EmployeeHealthAccount"],
});

export const { useGetEmployeeHealthAccountQuery, useUpdateEmployeeHealthAccountMutation } = employeeHealthAccountApi;
